





















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
import AppConsts from '@/lib/appconst';
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.ApplyWithdrawInputDto = new proxy.ApplyWithdrawInputDto();
    myaction = AppConsts.remoteServiceBaseUrl + "/File/GatherImageUploadPost";
    accounts = [];
    selectModel = ''
    get prox() {
        return new proxy.MerchantWithdrawOrderServiceProxy();
    }
    accountchange(e) {
        let m = this.accounts.find(x => x.id == e);
        this.model.bank = m.bank;
        this.model.bankName = m.bankName;
        this.model.bankNo = m.bankNo;
        this.model.bankProvince = m.bankProvince;
        this.model.bankZhiHang = m.bankZhiHang;
        this.$forceUpdate();
    }
    save() {
        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.prox.applyWithdraw(this.model).then(() => {
                    (this.$refs.roleForm as any).resetFields();
                    this.$Notice.success({ title: '保存成功' });
                    this.$emit('save-success');
                    this.$emit('input', false);
                });
            }
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            this.clear();
            let req = new proxy.MerchantRevAccountPageInputDto();
            req.maxResultCount = 100;
            new proxy.MerchantRevAccountServiceProxy().queryModelList(req).then(x => {
                this.accounts = x.items;
            })
            this.model = new proxy.ApplyWithdrawInputDto();
        }
    }
    clear() {
        this.selectModel = ''
    }
    roleRule = {
        suppName: [
            {
                required: true,
                message: this.L('FieldIsRequired'),
                trigger: 'blur'
            }
        ]
    };
}
